/**
 * Embed branding utilities.
 *
 * Branding is delivered by the verified JWT resolver — never take a
 * workspace id or brand config from the URL / postMessage / the parent
 * page. Doing so would defeat the isolation model.
 */

const CSS_VAR_MAP = {
  primary_color:    '--embed-primary',
  accent_color:     '--embed-accent',
  background_color: '--embed-bg',
  text_color:       '--embed-fg',
};

export function brandingCssVars(branding) {
  const vars = {};
  if (!branding || typeof branding !== 'object') return vars;
  for (const [key, cssVar] of Object.entries(CSS_VAR_MAP)) {
    const val = branding[key];
    if (val) vars[cssVar] = val;
  }
  return vars;
}

/** Inline `style` object for the outermost embed container. Applies
 * background/foreground overrides when provided. */
export function brandingRootStyle(branding) {
  const vars = brandingCssVars(branding);
  const s = { ...vars };
  if (branding?.background_color) s.backgroundColor = branding.background_color;
  if (branding?.text_color)       s.color = branding.text_color;
  return s;
}

/** Header (product name + logo) reused across all embed surfaces. */
export function brandingProductName(branding, fallback = 'Analytics') {
  return branding?.product_name || fallback;
}
